import { tenantIntegrationOptions } from '@/services/xverdict_config_mapper';

const JSON_START_CHARS = new Set(['{', '[', '"', '-', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 't', 'f', 'n']);
const EMPTY_RECORD = {};

export const TENANT_TABS = [
  { key: 'roles', label: 'Roles & people' },
  { key: 'domains', label: 'Case domains' },
  { key: 'rules', label: 'Rule engine' },
  { key: 'sla', label: 'SLAs & workflows' },
  { key: 'billing', label: 'Rates & billing' },
  { key: 'integrations', label: 'Integrations' },
  { key: 'branding', label: 'Branding & copy' }
];

export function parse_api_data(payload) {
  if (typeof payload !== 'string') return payload || EMPTY_RECORD;

  return should_parse_json(payload) ? JSON.parse(payload) : EMPTY_RECORD;
}

function should_parse_json(value = '') {
  return JSON_START_CHARS.has(String(value).trim().charAt(0));
}

export function clean_string(value) {
  return String(value || '').trim();
}

export function clean_phone(value) {
  return String(value || '').replace(/\D/g, '');
}

export function tenant_setup_form_defaults() {
  return {
    organisation_name: '',
    sector: 'Insurance Â· short-term',
    primary_contact: '',
    primary_email: '',
    primary_phone: '',
    domains: [],
    roles: [],
    integrations: ['microsoft_365', 'whatsapp_business']
  };
}

export const create_tenant_settings_state = () => ({
    active_tab: 'roles',
    tabs: TENANT_TABS,
    current_year: new Date().getFullYear(),
    show_tenant_setup_modal: false,
    tenant_setup_step: 1,
    tenant_setup_project_id: null,
    tenant_setup_contact_user_id: null,
    tenant_setup_contact_assigned: false,
    tenant_setup_project_types: [],
    tenant_setup_creating_project: false,
    tenant_setup_form: tenant_setup_form_defaults(),
    tenant_domain_options: [],
    tenant_domains_loading: false,
    tenant_domains_error: '',
    tenant_role_options: [],
    tenant_roles_loading: false,
    tenant_roles_saving: false,
    tenant_roles_error: '',
    tenant_integration_options: tenantIntegrationOptions({ setup_only: true }),
    role_records: [],
    roles_request: null,
    roles: [],
    people_records: [],
    people: [],
    roles_loading: false,
    people_loading: false,
    creating_role: false,
    updating_role: false,
    show_create_role_modal: false,
    show_edit_role_modal: false,
    roles_error: '',
    people_error: '',
    create_form: {
      role_name: '',
      role_description: ''
    },
    edit_form: {
      role_id: null,
      role_name: '',
      role_description: ''
    }
  });
